import { FocusContext } from '@noriginmedia/norigin-spatial-navigation'
import React, { useEffect } from 'react'
import type PBSError from '../../../../shared/PBSError'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import tts from '../../lib/TTS'
import FocusableButtonTS from '../FocusableButton/FocusableButtonTS'
import Modal from '../Modal'
import ErrorDescription from './ErrorDescription'
import type { ErrorModalProps } from './types'

const ERROR_MODAL_FOCUS_KEY = 'error-modal'

function ErrorModalTS({
  hideStationLogo,
  title,
  error,
  description,
  buttons,
}: ErrorModalProps) {
  const { ref, focusKey } = useHybridFocusable({
    focusKey: ERROR_MODAL_FOCUS_KEY,
    isFocusBoundary: true,
    preferredChildFocusKey: buttons[0]?.focusKey || '',
  })

  useEffect(() => {
    tts.stopRead()
    tts.addTextToRead(`${title} ... ${description}.`)
  }, [])

  const onEnterPressAux = (callback: () => void, label: string) => {
    callback?.()
    tts.pushTextToRead(`Pressed ${label} button.`)
  }

  return (
    <FocusContext.Provider value={focusKey}>
      <div className="error-modal visible" ref={ref}>
        <Modal hideStationLogo={hideStationLogo} error>
          {title ? <h1>{title}</h1> : null}
          {error && <ErrorDescription e={error as PBSError} />}
          {!error && description && <p>{description}</p>}

          {buttons.map((button, index) => (
            <FocusableButtonTS
              key={button.focusKey}
              focusKey={button.focusKey}
              onEnterPress={() =>
                onEnterPressAux(button.onEnterPress, button.label)
              }
              onFocus={() =>
                tts.enqueueTextToRead(`Focus on ${button.label} button.`)
              }
              className="error-modal__buttons-container__button"
              stealFocus={index === 0}
            >
              {button.label}
            </FocusableButtonTS>
          ))}
        </Modal>
      </div>
    </FocusContext.Provider>
  )
}

export default ErrorModalTS
